let uid = 0;

export function id(prefix = 'i') {
  return `${prefix}${uid++}`;
}
